import {useMutation, useQueryClient} from '@tanstack/react-query'

import {downloadCustomerImportTemplate, importCustomersCsv, previewCustomerImport} from './api'
import {customerKeys} from './query-keys'

export function useDownloadCustomerImportTemplate() {
    return useMutation({mutationFn: () => downloadCustomerImportTemplate()})
}

export function usePreviewCustomerImport() {
    return useMutation({mutationFn: (file: File) => previewCustomerImport(file)})
}

export function useImportCustomersCsv() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (file: File) => importCustomersCsv(file),
        onSuccess: (result) => {
            if (result.importedCount > 0) {
                void queryClient.invalidateQueries({queryKey: customerKeys.all})
            }
        },
    })
}
